import styled from 'styled-components';

export const BadgeStyled = styled.div<{ positive: boolean }>`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 8px;
	height: 20px;
	border-radius: 16px;
	background-color: ${props => (props.positive ? `#52C41A` : `#F5222D`)};
	color: #fff;
	font-size: 12px;
`;
